export var GalleryDisplayPossibilityOptions;
(function (GalleryDisplayPossibilityOptions) {
    GalleryDisplayPossibilityOptions["FULL"] = "FULL";
})(GalleryDisplayPossibilityOptions || (GalleryDisplayPossibilityOptions = {}));
